import ClickTracking from '@/share/campaign/click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'Facebook'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()
      const url = this.urlWithShareClickTokenInInnerUrl(this.sharingOptions.href, shareClickToken, 'u')
      this.openShareBox(url)
    },

    openShareBox(url) {
      window.open(url, 'sharer', 'toolbar=0,status=0,width=626,height=436')
    }
  }
}
